import script from "./RequestsCard.vue?vue&type=script&setup=true&lang=js"
export * from "./RequestsCard.vue?vue&type=script&setup=true&lang=js"

import "./RequestsCard.vue?vue&type=style&index=0&id=4a59cb99&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a59cb99"]])

export default __exports__